<script setup lang="ts">
const navLinks = [
  { label: 'About', to: '#about' },
  { label: 'Experience', to: '#experience' },
  { label: 'Projects', to: '#projects' },
  { label: 'Blog', to: '#blog' },
  { label: 'Contact', to: '#contact' }
]

const route = useRoute()
const heroNameVisible = ref(true)
const heroNameEl = ref<HTMLElement | null>(null)
const currentYear = new Date().getUTCFullYear()
const { y: scrollY } = useWindowScroll()

const isIndex = computed(() => route.path === '/')
const showName = computed(() => isIndex.value ? !heroNameVisible.value : scrollY.value > 60)

onMounted(() => {
  if (!isIndex.value) return
  heroNameEl.value = document.getElementById('hero-name')
  useIntersectionObserver(heroNameEl, ([{ isIntersecting }]) => {
    heroNameVisible.value = isIntersecting
  })
})
</script>

<template>
  <div>
    <UHeader
      :ui="{
        root: 'sticky top-0 z-50 backdrop-blur-md bg-background/80 border-b border-default/50',
        container: 'max-w-5xl mx-auto px-6',
        toggle: 'hidden'
      }"
    >
      <template #left>
        <NuxtLink
          to="/"
          aria-label="Go to homepage"
          class="flex items-center h-8 overflow-hidden"
        >
          <span class="sr-only">Home</span>
          <Transition name="navbar-name">
            <span
              v-if="showName"
              class="text-sm font-semibold text-highlighted tracking-tight select-none"
            >
              hardiyanto
            </span>
          </Transition>
        </NuxtLink>
      </template>

      <template #body>
        <nav class="hidden md:flex items-center gap-1">
          <a
            v-for="link in navLinks"
            :key="link.to"
            :href="link.to"
            class="px-3 py-1.5 text-sm text-muted hover:text-highlighted rounded-lg hover:bg-elevated transition-all"
          >
            {{ link.label }}
          </a>
        </nav>
      </template>

      <template #right>
        <UColorModeButton
          size="sm"
          variant="ghost"
        />
        <UButton
          to="https://github.com/devhardiyanto"
          target="_blank"
          icon="i-simple-icons-github"
          aria-label="GitHub"
          variant="ghost"
          size="sm"
        />
        <UButton
          to="https://linkedin.com/in/ihardiyanto"
          target="_blank"
          icon="i-simple-icons-linkedin"
          aria-label="LinkedIn"
          variant="ghost"
          size="sm"
        />
      </template>
    </UHeader>

    <UMain>
      <slot />
    </UMain>

    <UFooter
      :ui="{
        root: 'border-t border-default/50',
        container: 'max-w-5xl mx-auto px-6'
      }"
    >
      <template #left>
        <p class="text-xs text-muted">
          {{ currentYear }} Irfan Hardiyanto
        </p>
      </template>
      <template #right>
        <p class="text-xs text-muted">
          Inspired by <a
            href="https://lu.ma"
            target="_blank"
            class="hover:text-highlighted transition-colors"
          >luma.com</a>
        </p>
      </template>
    </UFooter>
  </div>
</template>

<style scoped>
.navbar-name-enter-active,
.navbar-name-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.navbar-name-enter-from {
  opacity: 0;
  transform: translateY(6px);
}
.navbar-name-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
</style>
